import { Container, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon,
    Edit as EditIcon, Search as SearchIcon, Visibility as VisibilityIcon
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import DateTimeField from '../../components/Form/Date';
import Select from '../../components/Form/Select';
import SelectSupplier from '../../components/Form/SelectSupplier';
import TextField from '../../components/Form/TextField';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { Filtro } from '../../interfaces/Asn';
import AsnApi from '../../services/AsnApi';
import OptionValueApi from '../../services/OptionValueApi';
import getDefaultGridOptions, { DataFormat, defaultHeaderOptions } from '../../utils/componentUtils';
import permissions from '../../utils/Permissions';
import useKeypress from '../../utils/useKeypress';
import { useStyles } from './Style';

interface Params {
    discriminator?: string;
}

const ASN: React.FC = () => {
    const params = useParams<Params>()
    const classes = useStyles();
    const [asns, setAsns] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [openedPainel, setOpenedPainel] = React.useState(false);
    const [asnStates, setAsnStates] = useState();
    const { user, hasPermission  } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("ASN");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    //Campos do Form
    interface IFormPanel {
        IssueDateEnd: Date | null;
        IssueDateStart: Date | null;
        id: any;
        invoiceKey: any;
        state: any;
        supplier: any;
        vehiclePlateNumber: any;
    }

    const statusesBlockedToEdit = ["REC", "CAN"];
    
    useEffect(() => {
        if (!hasPermission(permissions.ASN.Search))
            history.replace('/NoPermission');
    }, [history, user])

    useEffect(() => {
        OptionValueApi.search('StatusMvc').then(response => {
            if (response) {
                setAsnStates(response.map(
                    (item: any) => ({
                        code: item.code, label: item.description
                    })))
            }
        });
        setLoading(false);
    }, []);

    useEffect(() => {
        var data = getValues();

        var object = {pageIndex:page,pageSize:rowsPerPage, ...data};

        onSubmit(object);

        
    }, [page, rowsPerPage]);

    //Metodos do form:
    const { handleSubmit, reset, control, getValues, setError, resetField, setValue, setFocus } = useForm<IFormPanel>({
        defaultValues: {
            IssueDateEnd: null,
            IssueDateStart: null,
            id: '',
            invoiceKey: '',
            state: '',
            supplier: {},
            vehiclePlateNumber: '',
        }
    });

    const columns = [
        {
            name: 'asnNumber',
            label: t("asnNumber"),
            options: {
                ...defaultHeaderOptions,
                sort: false,
            }
        },
        {
            name: 'asnStatus',
            display: false,
            options: {
                display: false,
            }
        },
        {
            name: 'submitDate',
            label: t("issueDate"),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: DataFormat
            }
        },
        {
            name: 'vehiclePlateNumber',
            label: t('motorVehiclePlate'),
            options: {
                ...defaultHeaderOptions,
                sort: false,
            }
        },
        {
            name: "cartPlateNumber",
            label: String(t('cartPlateNumber2')),
            options: {
                ...defaultHeaderOptions,
                sort: false,
            }
        },
        {
            name: "asnStatusDescription",
            label: _t("status"),
            options: {
                ...defaultHeaderOptions,
                sort: false,
            }
        },  
        {
            name: "updatedBy",
            label: String(t('updatedBy')),
            options: {
                ...defaultHeaderOptions,
                sort: false,
            }
        },  
        {
            name: "updatedAt",
            label: String(t('updatedAt')),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: DataFormat
            }
        },   
        {
            name: "id",
            label: ' ',
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    <IconButton 
                        size='small'
                        color="primary"
                        edge="end"
                        onClick={() => history.push('/SubmitASN/'+value)}
                        disabled={(statusesBlockedToEdit.includes(tableMeta.rowData[1]))}
                    >
                        <EditIcon fontSize='small'/>
                    </IconButton>
                )
            }
        },  
        {
            name: "id",
            label: ' ',
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    <IconButton arial-label="View" color="primary"  edge="end" onClick={() => history.push('/ViewASN/'+value) }>
                        <VisibilityIcon fontSize='small'/>
                    </IconButton>
                )
            }
        },     
    ]

    useKeypress('Escape', () => {
        setOpenedPainel(false);
    });

    useEffect(() => {
        onSubmit({
            IssueDateEnd: '',
            IssueDateStart: '',
            id: '',
            invoiceKey: '',
            state: '',
            supplier: {},
            vehiclePlateNumber: '',
        });
    }, []);

    const onSubmit = async (data: any) => {
        setLoading(true);

        //Pesquisar somente por fornecedores do usuario:
        if (user.isSupplier)
            data.suppliers = user.suppliers;
        
        let filtro: Filtro = {
            AsnNumber: data.id,
            InvoiceKey: data.invoiceKey,
            SubmitDateStart: data.IssueDateStart,
            SubmitDateEnd: data.IssueDateStart,
            //TODO: Buscar ASN por supplier IDs (verificar tambem na API)
            //supplierIds: data.suppliers?.map((element: { code: any; }) => Number(element.code)).join(','),
            ShippingCompanySupplierCorporateName: data.supplier?.name,
            PlateNumber: data.vehiclePlateNumber,
            Status: data.state?.code,
            Discriminator: params.discriminator,
            pageSize: rowsPerPage,
            pageIndex: page,
        };

        AsnApi.search(filtro)
            .then(result => {
                if (result) {
                    setAsns(result.items);
                    setCount(result.totalCount);
                    setPage(result.pageIndex)
                }
                else {
                    setAsns([]);
                    setCount(0);
                    setPage(0)
                }
            }).catch(() => {
                setAsns([]);
            }).finally(() => {
                setLoading(false);
            });
    };


    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
        }
    })

    return (
        <Container maxWidth={false} component="main">
            <PageTitle title={t("pageTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={4} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>

                            </Grid>

                            <Grid item xs={8} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI color="secondary" onClick={() => history.push('/SubmitASN/')} startIcon={<AddIcon />}>{_t("add")}</ButtonUI>
                                <ButtonUI onClick={() => reset()} startIcon={<BackspaceOutlinedIcon />}>{_t("clean")}</ButtonUI>
                                <ButtonUI  type="submit" color="primary" startIcon={<SearchIcon />}>{_t("search")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>

                            <Grid item xs={2}>
                                <TextField label={t("asnCode")} name="id" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={4} >
                                <SelectSupplier
                                    id="supplier"
                                    name="supplier"
                                    label={t("supplierCode")}
                                    multiple={false}
                                    control={control}
                                    setValue={setValue}
                                    loadUserSupplier={true}
                                    style={{  width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <TextField label={t("invoiceKey")} name="invoiceKey" control={control} fullWidth />
                            </Grid>

                        </Grid>

                        <Grid container spacing={1}>

                            <Grid item xs={2}>
                                <DateTimeField
                                    label={t("IssueDateStart")} 
                                    name="IssueDateStart" 
                                    control={control} 
                                    InputLabelProps={{shrink:true}}
                                    fullWidth
                                    dateAndTime={false} /> 
                            </Grid>

                            <Grid item xs={2}>
                                <DateTimeField
                                    label={t("IssueDateEnd")} 
                                    name="IssueDateEnd" 
                                    control={control} 
                                    InputLabelProps={{shrink:true}}
                                    fullWidth
                                    dateAndTime={false} /> 
                            </Grid>

                            <Grid item xs={2}>
                                <Select 
                                    name='state'
                                    label={t("state")}
                                    control={control} 
                                    options={asnStates == null? [] : asnStates} />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("vehiclePlateNumber")} name="vehiclePlateNumber" mask="aaa9*99" control={control} fullWidth />
                            </Grid>

                        </Grid>
                        
                    </form>

                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={asns}
                                    columns={columns}
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: true,
                                        pagination: asns ? true : false,
                                        sort: asns ? true : false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        page,
                                        count,
                                        rowsPerPage,
                                        onChangePage: (pageIndex) => { setPage(pageIndex) },
                                        onChangeRowsPerPage: (rowsPerPage) => { setPage(0); setRowsPerPage(rowsPerPage) },
                                    }}
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default ASN;
